import React from "react";
import widgetIcon from "/images/widget-icon.webp";

interface StepAgentClosedProps {
  setStep: (step: number) => void;
}

const StepAgentClosed: React.FC<StepAgentClosedProps> = ({ setStep }) => {
  return (
    <div className="nut-flex nut-flex-col nut-gap-[10px] nut-items-end">
      <div className="gradient-wrap nut-w-[58px] nut-h-[57px] nut-bg-white nut-rounded-[50%] nut-p-[2.5px]">
        <button
          type="button"
          aria-label="Open NowUTalk shopping assistant"
          onClick={() => setStep(1)}
          className="content nut-cursor-pointer nut-flex nut-items-center nut-justify-center"
        >
          <img
            src={widgetIcon}
            alt="widget-icon"
            className="nut-w-[30px] nut-h-[29px]"
          />
        </button>
      </div>
    </div>
  );
};

export default StepAgentClosed;
